import React from 'react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

/**
 * App toaster (sonner) wired to the active color mode. Rendered once in `_app`.
 */
export function Toaster(props: ToasterProps) {
  const { resolvedTheme } = useTheme()

  return (
    <Sonner
      theme={(resolvedTheme as ToasterProps['theme']) ?? 'light'}
      position="bottom-center"
      richColors
      closeButton
      // Auto-dismiss is the default: every toast closes on its own after 5s
      // unless a caller passes an explicit `duration`. The close button stays
      // available for manual dismissal. Only genuine special cases (e.g. a
      // blocking error the user must act on) should opt out of auto-dismiss by
      // passing `duration: Infinity`.
      duration={5000}
      toastOptions={{
        classNames: {
          toast:
            'group rounded-md border border-line-subtle bg-surface-overlay text-content-primary shadow-lg',
          description: 'text-content-secondary',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-surface-subtle text-content-secondary',
        },
      }}
      {...props}
    />
  )
}

export default Toaster
